<template>
    <ul class="filter">
        <li class="filter__item" v-if="areas.length > 0 && filterFacets.includes('areas')">
            <label for="categoryFilter" class="sr-only">{{ dictionary.FilterCategoryArea }}</label>
            <select id="categoryFilter" v-model="area" :disabled="isLoading">
                <option value="All">{{ dictionary.FilterCategoryArea }}</option>
                <option v-for="areaItem in areas" :key="areaItem.Key" :value="areaItem.Key">{{
                    areaItem.Name
                }}
                </option>
            </select>
        </li>
        <li class="filter__item" v-if="departments.length > 0 && filterFacets.includes('departments')">
            <label for="functionalityFilter" class="sr-only">{{ dictionary.FilterCategoryDepartment }}</label>
            <select id="functionalityFilter" v-model="department" :disabled="isLoading">
                <option value="All">{{ dictionary.FilterCategoryDepartment }}</option>
                <option v-for="departmentItem in departments" :key="departmentItem.Key" :value="departmentItem.Key">{{
                    departmentItem.Name
                }}</option>
            </select>
        </li>
    </ul>
    <ul class="employee-items">
        <li class="employee-item" v-for="person in people" :key="person.EmployeeName">
            <div class="employee-item__inner">
                <div class="employee-item__image" v-if="person.HasImageSrcSet">
                    <ResponsiveImage :imageModel="person.ImageForVue" />
                </div>
                <div class="employee-item__info">
                    <div class="employee-item__row">
                        <h3 class="employee-item__name" v-if="person.EmployeeName">{{ person.EmployeeName }}</h3>
                        <p class="employee-item__title" v-if="person.EmployeeTitle">{{ person.EmployeeTitle }}</p>
                        <p class="employee-item__area" v-if="person.Area">{{ person.Area }}</p>
                    </div>
                    <div class="employee-item__row">
                        <p class="employee-item__text" v-if="person.EmployeeEmail">
                            {{ dictionary.EmployeeEmail }} <a :href="'mailto:' + person.EmployeeEmail" class="employee-item__link">{{
                                person.EmployeeEmail }}</a>
                        </p>
                        <p class="employee-item__text" v-if="person.EmployeePhone">
                            {{ dictionary.EmployeePhone }} <a :href="'tel:' + person.EmployeePhone" class="employee-item__link">{{
                                person.EmployeePhone }}</a>
                        </p>
                        <p class="employee-item__text" v-if="person.DirectPhone">
                            {{ dictionary.EmployeeDirectPhone }} <a :href="'tel:' + person.DirectPhone"
                                class="employee-item__link">{{ person.DirectPhone }}</a>
                        </p>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</template>
<script>

import { nextTick } from 'vue'
import ResponsiveImage from "./components/responsiveImage.vue";
const serviceUrl = "/umbraco/api/peopleapi/getPeople";

const defaultArea = "All";
const defaultDepartment = "All";
export default {
    name: "People",
    props: [
        "defaultResultSet",
        "filterFacets"
    ],
    components: {
        ResponsiveImage

    },
    data() {
        return {
            dictionary: [],
            culture: "da-DK",
            isLoading: false,
            hasLoadedInitials: false,
            area: defaultArea,
            department: defaultDepartment,
            areas: [],
            departments: [],
            people: []
        };
    },
    created() {
        this.culture = document.querySelector("html").getAttribute("lang");
    },
    mounted() {
        const vm = this;
        vm.getInitials();
    },
    watch: {
        area: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        department: {
            handler(newVal, oldVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },

    },
    methods: {
        getProjects() {
            const vm = this;

            vm.toggleSpinner(true);
            var object = {
                languageCode: vm.culture,
            };

            if (vm.area != defaultArea) {
                object.area = vm.area;
            }

            if (vm.department != defaultDepartment) {
                object.department = vm.department;
            }

            if (vm.defaultResultSet != null && vm.defaultResultSet.length > 0) {
                object.defaultSet = vm.defaultResultSet;
            }

            fetch(serviceUrl + "?" + new URLSearchParams(object))
                .then((response) => response.json())
                .then((data) => {
                    vm.people = data.Items;
                    vm.areas = data.Facets.Areas;
                    vm.departments = data.Facets.Departments;
                    vm.dictionary = data.Dictionary;

                    nextTick(() => {
                        vm.hasLoadedInitials = true;
                        vm.toggleSpinner(false);
                    });
                    vm.toggleSpinner(false);

                })
                .catch((error) => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
        },
        getInitials() {
            this.getProjects();
        },
        handleFilterPropertyChange(oldVal, newVal) {
            if (oldVal !== newVal) {
                if (this.hasLoadedInitials && !this.isLoading) {
                    this.filterChanged();
                }
            }
        },
        filterChanged() {
            this.isLoading = true;
            this.getProjects();
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    }
};
</script>
